export type LocationPermissionHelp =
  | 'chrome'
  | 'edge'
  | 'firefox'
  | 'safari'
  | 'ios'
  | 'android_chrome'
  | 'generic';

/**
 * Finds which instructions to show to a user that has to give the location permission, depending on
 * the browser and device in use.
 */
export const getLocationPermissionHelp = (
  userAgent: string = navigator.userAgent
): LocationPermissionHelp => {
  const isIos = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);

  // Every browser in iOS uses the system settings
  if (isIos) return 'ios';
  if (/Edg\//.test(userAgent)) return 'edge';
  if (/Firefox\//.test(userAgent)) return 'firefox';
  if (isAndroid && /Chrome\//.test(userAgent)) return 'android_chrome';
  if (/Chrome\//.test(userAgent)) return 'chrome';
  if (/Safari\//.test(userAgent)) return 'safari';

  return 'generic';
};
